var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "simple-message-container"
  }, [_c('div', {
    staticClass: "simple-message-avatar"
  }, [_c('Avatar', {
    attrs: {
      "url": _vm.props.avatar
    }
  })], 1), _c('div', [_c('div', {
    staticClass: "simple-message-sender"
  }, [_vm._v(" " + _vm._s(_vm.props.sender) + " ")]), _c('div', {
    staticClass: "simple-message-body"
  }, [_c('div', {
    class: {
      'simple-message-content': true,
      'no-padding': _vm.isNoPadding
    }
  }, [_vm._t("default")], 2), _c('div', {
    staticClass: "timestamp"
  }, [_vm._v(" " + _vm._s(_vm.calculateTimestamp(_vm.props.time * 1000)) + " ")])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }